var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addAdvertisingSDK.init()
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: !_vm.delIds.length },
                  on: {
                    click: function($event) {
                      return _vm.del(_vm.delIds)
                    }
                  }
                },
                [_vm._v("批量删除")]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60px", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { prop: "sdk_name", label: "广告SDK名称", sortable: "" }
          }),
          _c("el-table-column", {
            attrs: { prop: "sdk_version", label: "SDK版本", sortable: "" }
          }),
          _c("el-table-column", {
            attrs: { prop: "sdk_url", label: "SDK地址" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$utils.capy(row.sdk_url)
                          }
                        }
                      },
                      [_vm._v(_vm._s(row.sdk_url))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.addAdvertisingSDK.init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, sizes,prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
          })
        : _vm._e(),
      _c("addAdvertisingSDK", {
        ref: "addAdvertisingSDK",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }